// extracted by mini-css-extract-plugin
export default {"actionBox":"UsersRequestTable_actionBox__W3wvY","tourButton":"UsersRequestTable_tourButton__WxRJu"};